// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";
import { API_TIPO_PIEZAS } from "../views/MainLayout/components/shared/services/tipo_piezas";

const initialTipoPiezas = []

export const tipoPiezasFullfilledReducer = (state = initialTipoPiezas, action) => {
    switch(action.type){
        case "tipo_piezas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchTipoPiezas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_TIPO_PIEZAS.getTipoPiezas()
        const data = await response.data;
        dispatch({ type: 'tipo_piezas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}